class gforms {
	constructor() {
	}
	newsletter_signup_fix(el) {
		const form = el.querySelector('.gform_wrapper form');
		
		function formMarkup(el, form) {
			const input_group = document.createElement('div');
			input_group.setAttribute('class', 'input-group d-flex align-items-center');
			
			form.appendChild(input_group);
			
			input_group.appendChild(form.querySelector('.gform_body'));
			input_group.appendChild(form.querySelector('.gform_footer'));
			
			Array.from(form.querySelectorAll('input')).forEach(input => input.classList.add('form-control'));
		}

		formMarkup(el, form);
	}
}
window.app.add('gforms', new gforms());
